import * as React from 'react';
import { connect } from 'dva';
import { Form } from 'antd';
import './index.less';
import classNames from 'classnames';
import ABSInput from '../../../../components/ABSInput';
import { ABSButton } from '../../../../components/ABSButton';
import ABSMessage from '../../../../components/ABSMessage';
import routerConfig from '../../../config/routeConfig';
import ABSCaptcha from '../../../../components/ABSCaptcha';
import commonUtils from '../../../../utils/commonUtils';
import authService from '../../../services/auth/authService';
import LoginDataHelper from './LoginDataHelper';
import ABSLink from '../../../../components/ABSLink';
import ABSOtherLogin from '../../../../components/ABSOtherLogin';
import qs from 'qs';
import { API_ADDRESS, GlobalApi } from '../../../config/api';
import ABSIcon from '../../../../components/ABSIcon';
import ABSCheckbox from '../../../../components/ABSCheckbox';
import ABSModal from '../../../../components/ABSModal';
import Agreement from '../Register/Domestic/Phone/Agreement';
import PrivacyAgreement from '../Register/Domestic/Phone/PrivacyAgreement';

const FormItem = Form.Item;

class ABSLogin extends React.Component<any, any> {
  wechatModal;
  abslinkModal;
  cnabsHost: string;
  isLocal;
  isMobile;
  modal;
  privacyModal;
  // private errorMessage: string = '';

  constructor(props: any) {
    super(props);
    this.state = {
      isChange: false,
      errorMessage: '',
      agreementChecked: false
    };
    this.isLocal = document.referrer.indexOf('http://localhost:3000') !== -1;
    this.cnabsHost = this.isLocal ? 'http://localhost:3000' : API_ADDRESS || '';

    if (commonUtils.isMobile.any()) {
      this.isMobile = true;
    }
  }

  resolveLocalRouterRoot = url => {
    return this.isLocal ? url.replace('/app', '') : url;
  };

  componentDidMount() {
    const params = commonUtils.getParams();
    if (params) {
      if (params.message) {
        this.setState({ errorMessage: params.message });
      }
      const code = this.getQueryString('code');
      const state = this.getQueryString('state');
      if (code) {
        this.props
          .dispatch({
            type: 'account/wechatLogin',
            payload: {
              code: code,
              state: state
            }
          })
          .then(response => {
            if (!response) {
              return;
            }
            if (response.is_success) {
              authService.setAuthCache(response.data);
              location.href = routerConfig.home;
            } else {
              ABSMessage.error(response.fail_msg);
            }
          });
      }
    }
  }

  getQueryString(name: string) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r) {
      return unescape(r[2]);
    }
    return null;
  }

  onWechatLogin = () => {
    this.wechatModal.setState({ visible: true });
  };

  onAbsLinkDownload = () => {
    this.abslinkModal.setState({ visible: true });
  };

  onGoHome = () => {
    location.href = this.resolveLocalRouterRoot(this.cnabsHost + routerConfig.introduction);
  };

  onGoHelp = () => {
    location.href = this.resolveLocalRouterRoot(this.cnabsHost + routerConfig.feedback);
  };

  onDeleteBtn(e: any) {
    if (e.user_name) {
      this.props.form.setFieldsValue({
        user_name: ''
      });
    }
  }
  onOpenAgreement = () => {
    this.modal.show(true);
  };
  onOpenPrivacyAgreement = () => {
    this.privacyModal.show(true);
  };
  onChange = (e: any) => {
    // ABSMessage.warning('登录、注册必须同意该协议！');
    this.setState({ agreementChecked: e.target.checked });
  };
  onSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.state.agreementChecked) {
          ABSMessage.warning('登录、注册必须同意该协议！');
          return;
        }
        this.props
          .dispatch({
            type: 'account/login',
            payload: LoginDataHelper.formatValue(values)
          })
          .then(response => {
            if (response === 'ok') {
              if (this.props.isHomeMenuLogin === true) {
                location.href = routerConfig.login;
                return;
              }
              let params = qs.parse(location.hash.split('?')[1]);
              let returnUrl = routerConfig.home;
              if (params && params.return_url) {
                returnUrl = params.return_url;
              } else {
                params = qs.parse(location.search.split('?')[1]);
                if (params && params.return_url) {
                  returnUrl = params.return_url;
                }
              }
              location.href = returnUrl;
            } else {
              this.setState({ isChange: !this.state.isChange });
            }
          });
      }
      // else {
      //   this.setState({ errorMessage: '' });
      //   this.errorMessage = '';
      //   const { captcha } = err;
      //   if (captcha) {
      //     this.errorMessage = '请输入验证码';
      //   }
      // }
    });
  };

  render() {
    if (authService.checkIsLogin()) {
      location.href = routerConfig.home;
      return;
    }
    const { form, isHomeMenuLogin } = this.props;
    const { getFieldDecorator } = form;
    const { isChange, errorMessage } = this.state;
    const classs = classNames('abs-login', { 'abs-login-mobile': this.isMobile }, { 'abs-login-home': isHomeMenuLogin });
    const userName = this.props.form.getFieldsValue(['user_name']);
    // const captchaValidate: any = commonUtils.getValidate(this.errorMessage);
    const capchaUrl: string = GlobalApi.captcha2 + '?type=Login';

    return (
      <div className={classs}>
        <div className={`abs-login-bg`} />
        <div className={`abs-login-content`}>
          <div className={`abs-login-content-backhome`}>
            <ABSButton className="btn-backhelp backhelp-0714" onClick={this.onGoHelp}>
              帮助
            </ABSButton>
            <ABSButton className="btn-backhome" onClick={this.onGoHome}>
              回到主页
            </ABSButton>
          </div>
          <div className={`abs-login-content-title`}>登录</div>
          <Form onSubmit={this.onSubmit} className={`abs-login-form`}>
            <FormItem>
              {getFieldDecorator('user_name', {
                rules: [
                  {
                    required: true,
                    message: '请输入用户名或手机号'
                  }
                ]
              })(
                <ABSInput
                  placeholder="请输入用户名或手机号"
                  onDelete={() => this.onDeleteBtn(userName)}
                  isSuffix={true}
                  prefix={<ABSIcon isAnt={true} type="user" />}
                  size="large"
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: '请输入密码' }]
              })(<ABSInput placeholder="请输入密码" prefix={<ABSIcon isAnt={true} type="lock" />} size="large" type="password" isSuffix={true} />)}
            </FormItem>
            <FormItem className="form-item-captcha">
              {getFieldDecorator('captcha', {
                rules: [
                  {
                    required: true,
                    message: '请输入验证码'
                  }
                ]
              })(
                <ABSInput
                  placeholder="请输入验证码"
                  type="text"
                  addonAfter={<ABSCaptcha url={capchaUrl} isChange={isChange} className="login-captcha" />}
                  size="large"
                />
              )}
            </FormItem>
            <div className="abs-domestic-phone-aggrement">
              <ABSCheckbox content="勾选代表你已阅读并同意" value="2" checked={this.state.agreementChecked} onChange={this.onChange} removeMarginRight={true} />
              <span className="abs-domestic-phone-aggrement-modal">
                <a onClick={this.onOpenAgreement}>《用户协议》</a>
                <a onClick={this.onOpenPrivacyAgreement}>《用户隐私协议》</a>
              </span>
            </div>
            <ABSModal content={<Agreement />} title={'《用户协议》'} width={800} footer={null} ref={view => (this.modal = view)} />
            <ABSModal content={<PrivacyAgreement />} title={'《用户隐私协议》'} width={800} footer={null} ref={view => (this.privacyModal = view)} />
            <FormItem className="form-item-submit">
              <span className={'form-item-submit-error'}>{errorMessage}</span>
              <ABSButton htmlType="submit" className="abs-login-btn">
                登录
              </ABSButton>
            </FormItem>
          </Form>

          <div className={`abs-login-content-account`}>
            <span className={`abs-login-content-account-resetpwd`}>
              <ABSLink to={this.resolveLocalRouterRoot(this.cnabsHost + routerConfig.resetPwd)}>忘记密码</ABSLink>
            </span>
            <span className={`abs-login-content-account-register`}>
              <ABSLink to={this.resolveLocalRouterRoot(this.cnabsHost + routerConfig.registerOfLogin)}>点击注册</ABSLink>
            </span>
            <span className={`abs-login-content-account-noaccount`}>*还没有CNABS账号？</span>
          </div>
          <ABSOtherLogin />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: any) {
  return { ...state.account };
}

export default connect(mapStateToProps)(Form.create()(ABSLogin));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/account/Login/index.tsx